import { gql } from '@apollo/client';

/**
 * Mutation to set employee weekly schedule
 */
export const SET_EMPLOYEE_WEEKLY_SCHEDULE = gql`
  mutation SetEmployeeWeeklySchedule($input: SetEmployeeWeeklyScheduleInput!) {
    setEmployeeWeeklySchedule(input: $input)
  }
`;

/**
 * Mutation to create or update a company holiday
 */
export const UPSERT_COMPANY_HOLIDAY = gql`
  mutation UpsertCompanyHoliday($input: CompanyHolidayInput!) {
    upsertCompanyHoliday(input: $input) {
      id
      name
      date
      description
      createdAt
      updatedAt
    }
  }
`;

/**
 * Mutation to delete a company holiday
 */
export const DELETE_COMPANY_HOLIDAY = gql`
  mutation DeleteCompanyHoliday($id: ID!) {
    deleteCompanyHoliday(id: $id)
  }
`;

/**
 * Mutation to create employee vacation
 */
export const CREATE_EMPLOYEE_VACATION = gql`
  mutation CreateEmployeeVacation($input: EmployeeVacationInput!) {
    createEmployeeVacation(input: $input) {
      id
      userId
      startDate
      endDate
      vacationType
      reason
      approvalStatus
      reviewedAt
      reviewNote
      createdAt
      updatedAt
      user {
        id
        firstName
        lastName
        name
      }
    }
  }
`;

/**
 * Mutation to update employee vacation
 */
export const UPDATE_EMPLOYEE_VACATION = gql`
  mutation UpdateEmployeeVacation($id: String!, $input: EmployeeVacationInput!) {
    updateEmployeeVacation(id: $id, input: $input) {
      id
      userId
      startDate
      endDate
      vacationType
      reason
      approvalStatus
      reviewedAt
      reviewNote
      createdAt
      updatedAt
      user {
        id
        firstName
        lastName
        name
      }
    }
  }
`;

/**
 * Mutation to delete employee vacation
 */
export const DELETE_EMPLOYEE_VACATION = gql`
  mutation DeleteEmployeeVacation($id: String!) {
    deleteEmployeeVacation(id: $id)
  }
`;

export const REVIEW_EMPLOYEE_VACATION = gql`
  mutation ReviewEmployeeVacation($id: String!, $decision: VacationReviewDecision!, $reviewNote: String) {
    reviewEmployeeVacation(id: $id, decision: $decision, reviewNote: $reviewNote) {
      id
      userId
      startDate
      endDate
      vacationType
      reason
      approvalStatus
      reviewedAt
      reviewNote
      reviewedBy {
        id
        name
      }
      updatedAt
    }
  }
`;

/**
 * Admin: set or clear another employee's coverage / back-up contact.
 * Pass null for coverageUserId to clear an existing selection.
 */
export const SET_EMPLOYEE_COVERAGE = gql`
  mutation SetEmployeeCoverage($userId: Int!, $coverageUserId: Int) {
    setEmployeeCoverage(userId: $userId, coverageUserId: $coverageUserId)
  }
`;

/**
 * Admin: upsert a per-date schedule override for another employee.
 * Saving the same date again replaces the previous override.
 */
export const SET_EMPLOYEE_SCHEDULE_OVERRIDE = gql`
  mutation SetEmployeeScheduleOverride($userId: Int!, $input: ScheduleOverrideInput!) {
    setEmployeeScheduleOverride(userId: $userId, input: $input) {
      id
      date
      isWorking
      isRemote
      notes
    }
  }
`;

/**
 * Admin: remove a per-date schedule override for another employee so the
 * date falls back to the recurring weekly pattern.
 */
export const CLEAR_EMPLOYEE_SCHEDULE_OVERRIDE = gql`
  mutation ClearEmployeeScheduleOverride($userId: Int!, $date: Timestamp!) {
    clearEmployeeScheduleOverride(userId: $userId, date: $date)
  }
`;
